package one.healthium.tutorial.domain

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.PlatformSerializers
import one.healthium.domain.common.TextStyle
import one.healthium.onboarding.domain.configs.Notification
import one.healthium.onboarding.domain.models.HighlightItem

@Serializable
sealed interface TutorialScreenConfig {
    @Serializable
    @SerialName("info")
    data class TutorialInfoScreenConfig(
        @SerialName("title") val title: String? = null,
        @SerialName("title_style") val titleStyle: TextStyle? = null,
        @SerialName("message") @Serializable(with = PlatformSerializers::class) val message: String? = null,
        @SerialName("cta_title") val ctaTitle: String? = null,
    ) : TutorialScreenConfig

    @Serializable
    @SerialName("notifications_access")
    data class TutorialNotificationsAccessScreenConfig(
        @SerialName("title") val title: String? = null,
        @SerialName("subtitle") val subtitle: String? = null,
        @SerialName("cta_title") val ctaTitle: String? = null,
        @SerialName("cta_cancel_title") val ctaCancelTitle: String? = null,
        @SerialName("notification") val notification: Notification? = null,
    ) : TutorialScreenConfig

    @Serializable
    @SerialName("transparency_access")
    data class TutorialTransparencyAccessScreenConfig(
        @SerialName("title") val title: String? = null,
        @SerialName("title_style") val titleStyle: TextStyle? = null,
        @SerialName("subtitle") val subtitle: String? = null,
        @SerialName("benefits_title") val benefitsTitle: String? = null,
        @SerialName("cta_title") val ctaTitle: String? = null,
        @SerialName("text_label") val textLabel: TextStyle? = null,
        @SerialName("benefits_title_label") val benefitsTitleLabel: TextStyle? = null,
        @SerialName("emoji_height") val emojiHeight: Int? = null,
        @SerialName("items") val items: List<HighlightItem> = emptyList(),
    ) : TutorialScreenConfig
}